import React from "react";
import Skeleton from "../feedback/Skeleton";

/**
 * Загрузка страницы. Скелетон вместо GIF-спиннера и пустого заголовка.
 */
const Loader = ({variant = "table"}) => (
    <div className="ui-loader" role="status" aria-live="polite">
        <span className="sr-only">Загрузка данных…</span>
        <Skeleton variant="page"/>
        <Skeleton variant={variant} rows={6}/>
    </div>
);

export default Loader;